import styled from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const StartSpeedDatingWrapper = styled.div`
  .content_user {
    height: 65vh;
    overflow: auto;
    margin: 0 auto 20px;

    .user_card {
      height: auto;
      overflow-x: hidden;
    }

    svg {
      height: 200px !important;
    }

    @media (max-width: ${TABLET_WIDTH}px) {
      padding: 0px;
      height: calc(55vh - env(safe-area-inset-top));
      svg {
        height: 120px !important;
      }
    }
  }

  .footer {
    text-align: center;
  }

  .title_start {
    font-size: 24px;
    color: #444;
    font-weight: 600;
    margin-bottom: 20px;

    @media (max-width: ${TABLET_WIDTH}px) {
      font-size: 18px;
      line-height: 18px;
      margin-bottom: 10px;
    }
  }

  button {
    min-width: 100px;
  }

  .phrase {
    font-size: 16px;
    color: #666;
    font-weight: 600;
    margin: 20px 0;

    @media (max-width: ${TABLET_WIDTH}px) {
      font-size: 14px;
      margin: 10px 0;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/NotificationsTypes/StartSpeedDating/components/styles.js